import { createSlice } from '@reduxjs/toolkit'

import config from '@app/config'

import { isWebView } from '@app/utils'

import { initialState } from './constants'
import { getConfigurationThunk } from './thunks'

import { IdentityConfiguration } from '../../models'

const configurationSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getConfigurationThunk.fulfilled, (_, action) => {
      const identity = action.payload as IdentityConfiguration
      const isInWebView = isWebView()
      config.identity = {
        ...identity,
        isWebView: isInWebView,
        isB2CWebView: isInWebView && !identity.isBackOffice,
      }
      return identity
    })

    builder.addCase(getConfigurationThunk.rejected, () => {
      console.error('Cannot get configuration')
    })
  },
})

export default configurationSlice.reducer
